import styled from 'styled-components';

export const PlanContainer = styled.div`
  padding: 40px 24px 40px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.bgSecondary};

  .message {
    display: flex;
    justify-content: center;
    margin: 24px;
    padding: 0 0 24px;

    h2 {
      margin: 0;
      color: ${({ theme }) => theme.colors.textEmphasis};
      font-size: 28px;
      font-weight: 700;
      line-height: 28px;
      text-align: center;
    }
  }
`;
